import type {NavbarItemInterface} from "@/components/helpers/Interfaces.ts";
import {routes} from "@/components/widget/TopNavigation/routes.ts";

export function useNavbar(userRole: string) {
    const getFilteredNavbarItems = (): NavbarItemInterface[] => {
        return routes
            .filter(item => {
                // If the item has a `roles` property, check if the user has any of those roles
                if (item.roles) {
                    return item.roles.some(role => userRole.includes(role));
                }
                // If no roles property, the item is accessible to all users
                return true;
            })
            .map(item => {
                // If the item has subitems, filter them as well
                if (item.subitems) {
                    item.subitems = item.subitems.filter(subitem => {
                        if (subitem.roles) {
                            return subitem.roles.some(role => userRole.includes(role));
                        }
                        return true;
                    });
                }
                return item;
            });
    };

    return {
        items: getFilteredNavbarItems()
    }
}
